import React, { Component } from "react"
import PropTypes from "prop-types"

import SingleChoice from "./SingleChoice"
import ExpandButton from "./ExpandButton"
import Autosuggest from "react-autosuggest"
import orderByDistance from "geolib/es/orderByDistance"

// We combine the styles of the InputField with custom styles for the autosuggest
import filterStyles from "./DepartmentSelectorFilterInput.module.scss"
import inputFieldStyles from "./InputField.module.sass"

const parseCoordinates = (obj) => ({
  ...obj,
  latitude: parseFloat(obj.latitude),
  longitude: parseFloat(obj.longitude),
})

class DepartmentSelector extends Component {
  static propTypes = {
    choices: PropTypes.array.isRequired,
    doneCallback: PropTypes.func,
    theme: PropTypes.object.isRequired,
    stepName: PropTypes.string,
    postcodesForTypeaheadUrl: PropTypes.string,
    labels: PropTypes.object,
    onCapturePostCode: PropTypes.func,
  }

  state = {
    withLocationFilter: this.props.choices.every(
      (department) => department.location
    ),
    suggestions: [],
    suggestedSelected: false,
    choices: this.props.choices.map((choice) =>
      // Parse coordinates of location on each choice if there is a location
      choice.location
        ? { ...choice, ...parseCoordinates(choice.location) }
        : choice
    ),
    filterValue: "",
    allOptionsToggled: false,
    suggestionsEnabled: false,
  }

  _getSuggestionValue = (suggestion) => suggestion.value

  _onSuggestionsFetchRequested = ({ value }) => {
    fetch(
      `${this.props.postcodesForTypeaheadUrl}?query=${encodeURIComponent(
        value
      )}`,
      {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
      }
    )
      .then((res) => res.json()) // TODO: Handle failure when res status is not 200
      .then((data) => {
        this.setState({
          suggestions: data.map(parseCoordinates),
        })
      })
  }

  _onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] })
  }

  _onSuggestionSelected = (_event, { suggestion }) => {
    this.setState((prevState) => ({
      choices: orderByDistance(suggestion, prevState.choices),
      suggestedSelected: true,
    }))
  }

  _filterValueChanged = (_event, { newValue }) => {
    this.setState((prevState) => {
      const firstSuggestion = prevState.suggestions[0]
      const newState = { filterValue: newValue }
      if (firstSuggestion && newValue === firstSuggestion.value) {
        // Automatically select first suggestion when postcode matches
        newState.choices = orderByDistance(firstSuggestion, prevState.choices)
        newState.suggestionsEnabled = false
        newState.suggestedSelected = true
      } else {
        // Do not display suggestions if typed less than 1 character
        newState.suggestionsEnabled = newValue.length > 1
      }
      return newState
    })
    this.props.onCapturePostCode(newValue)
  }

  _renderSuggestion = (suggestion) => <div>{suggestion.name}</div>

  _toggleAllOptions = () => {
    this.setState((prevState) => ({
      allOptionsToggled: !prevState.allOptionsToggled,
    }))
  }

  render() {
    const inputProps = {
      placeholder: this.props.labels.placeholders.departmentFilter,
      value: this.state.filterValue,
      onChange: this._filterValueChanged,
      autoFocus: true,
    }

    const visibleChoices = this.state.allOptionsToggled
      ? this.state.choices
      : this.state.choices.slice(0, 5)

    return (
      <React.Fragment>
        {this.state.withLocationFilter && (
          <Autosuggest
            suggestions={this.state.suggestions}
            onSuggestionsFetchRequested={this._onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this._onSuggestionsClearRequested}
            onSuggestionSelected={this._onSuggestionSelected}
            getSuggestionValue={this._getSuggestionValue}
            renderSuggestion={this._renderSuggestion}
            shouldRenderSuggestions={() => this.state.suggestionsEnabled}
            inputProps={inputProps}
            highlightFirstSuggestion
            theme={{
              ...filterStyles,
              input: "unstyled " + inputFieldStyles.input,
              container:
                filterStyles.container +
                " " +
                inputFieldStyles.inputContainer +
                " " +
                inputFieldStyles.searchContainer,
            }}
          />
        )}
        {((this.state.filterValue && this.state.suggestedSelected) ||
          !this.state.withLocationFilter ||
          this.state.allOptionsToggled) && (
            <SingleChoice
              choices={visibleChoices}
              doneCallback={this.props.doneCallback}
              fullWidthOptions
              theme={this.props.theme}
              stepName={this.props.stepName}
              labels={this.props.labels}
            />
          )}
        {this.state.choices.length > 5 &&
          !this.state.allOptionsToggled &&
          (this.state.filterValue || !this.state.withLocationFilter) && (
            <ExpandButton
              onClick={this._toggleAllOptions}
              label={this.props.labels.showMore}
            />
          )}
      </React.Fragment>
    )
  }
}

export default DepartmentSelector
